import { gql } from '@apollo/client';

export const USER_PROFILE = gql`
  query getUserProfile {
    userProfile {
      firstName
      lastName
      vendorName
      email
      preferences {
        regions
      }
    }
  }
`;
